import React from "react";
import UploadSection from "./UploadSection";

type UploadStage = "idle" | "uploading" | "uploaded" | "error";

interface Props {
  file: File | null;
  onChange: (file: File | null) => void;
  uploadStage: UploadStage;
  progress: number;
  onCancel: () => void;
  onDelete?: () => void;
  isEditingPublished?: boolean;
}

const ThumbnailUpload: React.FC<Props> = ({
  file,
  onChange,
  uploadStage,
  progress,
  onCancel,
  onDelete,
  isEditingPublished,
}) => (
  <UploadSection
    title="Thumbnail"
    description=""
    formats="JPEG, PNG (400x400 min.)"
    onFileChange={onChange}
    currentFile={file}
    accept=".jpg,.jpeg,.png"
    uploadStage={uploadStage}
    progress={progress}
    onCancel={onCancel}
    onDelete={onDelete}
    isEditingPublished={isEditingPublished}
  />
);

export default ThumbnailUpload;
